import { useEffect } from "react";
import { useMatches } from "react-router-dom";

type RouteHandle = {
  title?: string;
};

const useTitle = () => {
  const matches = useMatches();

  useEffect(() => {
    const base = "AAM Hub";

    const currentRoute = matches[matches.length - 1];

    const page =
      (currentRoute?.handle as RouteHandle)?.title;

    document.title = page ? `${base} - ${page}` : base;
  }, [matches]);
};

export default useTitle;